export const extractVideoInfo = (link) => {
  try {
    const url = new URL(link);
    const host = url.hostname;
    const path = url.pathname;

    // YouTube
    if (host === 'www.youtube.com' && path === '/watch') {
      const id = url.searchParams.get('v');
      return id ? { platform: 'youtube', id } : null;
    }

    if (host === 'youtu.be') {
      const id = path.slice(1);
      return id ? { platform: 'youtube', id } : null;
    }

    // Vimeo
    if (host === 'vimeo.com') {
      const parts = path.split('/').filter(Boolean);
      const id = parts.includes('video') ? parts[1] : parts[0];
      return id ? { platform: 'vimeo', id } : null;
    }

    return null;
  } catch {
    return null;
  }
};
